<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :viewbox-width="width"
        :viewbox-height="height"
        :color="color"
        @click="$emit('click')"
    >
        <path
            class="a"
            d="M12 24.8359C5.383 24.8359 0 19.4529 0 12.8359C0 6.21894 5.383 0.835938 12 0.835938C18.617 0.835938 24 6.21894 24 12.8359C24 19.4529 18.617 24.8359 12 24.8359ZM12 2.33594C6.21 2.33594 1.5 7.04594 1.5 12.8359C1.5 18.6259 6.21 23.3359 12 23.3359C17.79 23.3359 22.5 18.6259 22.5 12.8359C22.5 7.04594 17.79 2.33594 12 2.33594Z"
        />
        <path
            class="a"
            d="M12 14.3369C10.759 14.3369 9.75 13.3279 9.75 12.0869C9.75 10.8459 10.759 9.83694 12 9.83694C12.537 9.83694 13.054 10.0309 13.46 10.3779L18.77 7.31194C18.884 7.24594 19.013 7.21094 19.145 7.21094C19.412 7.21094 19.661 7.35494 19.795 7.58594C19.895 7.75894 19.921 7.96094 19.87 8.15494C19.818 8.34894 19.694 8.50994 19.521 8.61094L14.212 11.6759C14.238 11.8119 14.251 11.9489 14.251 12.0869C14.25 13.3279 13.241 14.3369 12 14.3369ZM12 11.3369C11.586 11.3369 11.25 11.6729 11.25 12.0869C11.25 12.5009 11.586 12.8369 12 12.8369C12.414 12.8369 12.75 12.5009 12.75 12.0869C12.75 11.6729 12.414 11.3369 12 11.3369Z"
        />
        <path
            class="a"
            d="M9 20.3359C7.759 20.3359 6.75 19.3269 6.75 18.0859C6.75 16.8449 7.759 15.8359 9 15.8359H15C16.241 15.8359 17.25 16.8449 17.25 18.0859C17.25 19.3269 16.241 20.3359 15 20.3359H9ZM9 17.3359C8.586 17.3359 8.25 17.6719 8.25 18.0859C8.25 18.4999 8.586 18.8359 9 18.8359H15C15.414 18.8359 15.75 18.4999 15.75 18.0859C15.75 17.6719 15.414 17.3359 15 17.3359H9Z"
        />
        <path
            class="a"
            d="M9.69104 6.49394C9.37704 6.49394 9.09404 6.29594 8.98604 6.00094L8.47304 4.59194C8.33204 4.20294 8.53304 3.77194 8.92104 3.63094C9.00404 3.60094 9.09004 3.58594 9.17704 3.58594C9.49104 3.58594 9.77404 3.78394 9.88204 4.07894L10.395 5.48794C10.536 5.87694 10.335 6.30794 9.94704 6.44894C9.86504 6.47894 9.77804 6.49394 9.69104 6.49394Z"
        />
        <path
            class="a"
            d="M6.15409 9.46094C6.02309 9.46094 5.89309 9.42594 5.77909 9.35994L4.48009 8.60994C4.30709 8.50994 4.18209 8.34794 4.13109 8.15494C4.07909 7.96094 4.10509 7.75894 4.20609 7.58594C4.34009 7.35494 4.58909 7.21094 4.85609 7.21094C4.98709 7.21094 5.11609 7.24594 5.23009 7.31094L6.52909 8.06094C6.70209 8.16094 6.82709 8.32294 6.87809 8.51594C6.93009 8.71094 6.90409 8.91294 6.80309 9.08594C6.67009 9.31694 6.42109 9.46094 6.15409 9.46094Z"
        />
        <path
            class="a"
            d="M3.87501 14.2688C3.51101 14.2688 3.20001 14.0088 3.13701 13.6488C3.06501 13.2418 3.33801 12.8518 3.74501 12.7798L5.22301 12.5188C5.26701 12.5108 5.31001 12.5078 5.35301 12.5078C5.71801 12.5078 6.02901 12.7678 6.09201 13.1278C6.16401 13.5348 5.89101 13.9248 5.48401 13.9968L4.00601 14.2578C3.96201 14.2648 3.91801 14.2688 3.87501 14.2688Z"
        />
        <path
            class="a"
            d="M14.3091 6.49103C14.2211 6.49103 14.1351 6.47603 14.0521 6.44603C13.8641 6.37703 13.7131 6.24003 13.6291 6.05803C13.5451 5.87603 13.5361 5.67303 13.6041 5.48403L14.1171 4.07503C14.2241 3.78003 14.5081 3.58203 14.8221 3.58203C14.9091 3.58203 14.9951 3.59703 15.0781 3.62703C15.2671 3.69603 15.4171 3.83403 15.5021 4.01503C15.5861 4.19703 15.5951 4.40003 15.5271 4.58903L15.0141 5.99803C14.9061 6.29303 14.6231 6.49103 14.3091 6.49103Z"
        />
        <path
            class="a"
            d="M20.125 14.2688C20.082 14.2688 20.038 14.2648 19.994 14.2578L18.516 13.9968C18.109 13.9248 17.836 13.5348 17.908 13.1278C17.972 12.7688 18.283 12.5078 18.647 12.5078C18.69 12.5078 18.733 12.5118 18.777 12.5188L20.255 12.7798C20.662 12.8518 20.935 13.2418 20.863 13.6488C20.8 14.0088 20.49 14.2688 20.125 14.2688Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'OdometerIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: currentColor;
    stroke: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
